import React, {useState} from "react";
import {Col, CustomInput, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label, Row,} from "reactstrap";
import assets from "../../../../../util/assets";
import SingleRowRequestComponent from "../../../../../components/Video/request/SingleRowRequestComponent";

const RequestReceived = (props) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownToggle = () => setDropdownOpen((prevState) => !prevState);

    if(props.video){
        return (
            <SingleRowRequestComponent
                req_id={props.req_id}
                userName={props.userName}
                userImage={props.userImage}
                user_id={props.user_id}
                userRequest={props.userRequest}
                userRequestHourAgo={props.userRequestHourAgo}
                status={props.status}
                isFavourite={props.isFavourite}
                index={props.index}
                isChecked={props.isChecked}
                radioToggle={props.radioToggle}
                favorite={props.favorite}
                unFavorite={props.unFavorite}
                blockUser={props.blockUser}
                removeRequest={props.removeRequest}
                acceptRequestData={props.acceptRequestData}
                dropdownOpen={dropdownOpen}
                setDropdownOpen={setDropdownOpen}
                dropdownToggle={dropdownToggle}
                type={"onetoone"}
            />
        )
    }

    return (
        <React.Fragment>
            <Col
                md="12"
                sm="12"
                className="border-bottom px-4"
                {...(`oneToOneRadio_${props.index}` === props.isChecked
                    ? {style: {background: "#E8F1F8"}}
                    : {})}>

                <Row className="py-md-2 px-1">
                    <Col md="12" sm="6">
                        <Row>
                            <Col md="1" sm="1" className="pr-0">
                                <Label className="my-md-3">
                                    <CustomInput
                                        type="radio"
                                        id={`oneToOneRadio_${props.index}`}
                                        name={`oneToOneRadio_${props.index}`}
                                        value={`oneToOneRadio_${props.index}`}
                                        checked={`oneToOneRadio_${props.index}` === props.isChecked}
                                        onChange={props.radioToggle}
                                        onClick={() => {
                                            props.acceptRequestData(props.req_id, "onetoone");
                                        }}
                                    />
                                </Label>
                            </Col>
                            <Col md="11" sm="11" className="pl-0 mt-md-2">
                                <Row>
                                    <Col md="8" sm="8" className="px-0">
                                        <Row className="pl-md-2">
                                            <Col md="1" sm="2" className="px-0">
                                                <img
                                                    className="img-fluid rounded-circle"
                                                    src={props.userImage}
                                                    alt="personspic"
                                                    width="48"
                                                    height="48"
                                                />
                                            </Col>
                                            <Col md="11" sm="10">
                                                <Row>
                                                    <Col md="12" sm="12">
                                                        <span className="text-capitalize requested-username">
                                                          {props.userName}
                                                        </span>
                                                    </Col>
                                                    <Col md="12" sm="12" className="display-flex">
                                                        <span className="text-left has-requested-a-1-on">
                                                          {props.userRequest}
                                                        </span>
                                                        <span className="ml-4 text-right human-readable-time">
                                                            {props.userRequestHourAgo}
                                                        </span>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col md="4" sm="4" className="display-flex-center">
                                        <Row>
                                            <Col md={{size: 3, offset: 5}} sm="3"
                                                 className="text-md-right py-2 px-0">
                                                <img
                                                    src={props.isFavourite ? assets.favourite_icon_enabled : assets.favourite_icon_disabled}
                                                    alt="personspic"
                                                    style={{width: 24, height: 21}}/>
                                            </Col>
                                            <Col md="3" sm="3">
                                                <Dropdown
                                                    isOpen={dropdownOpen}
                                                    toggle={() => dropdownToggle()}
                                                    direction={"left"}>
                                                    <DropdownToggle
                                                        color="link"
                                                        className="text-decoratin-none p-0">
                                                        <img src={dropdownOpen ? assets.more_selected : assets.more}
                                                             alt="personspic"/>
                                                    </DropdownToggle>
                                                    <DropdownMenu className="border-0 p-2 threeDotMenu"
                                                                  name={props.user_id}>
                                                        <DropdownItem
                                                            className="p-2 border-bottom"
                                                            onClick={() => {
                                                                props.isFavourite
                                                                    ? props.unFavorite(props.user_id, "one_to_one")
                                                                    : props.favorite(props.user_id, "one_to_one");
                                                            }}>
                                                            {props.isFavourite
                                                                ? "Unfavourite user"
                                                                : "Favourite user"}
                                                        </DropdownItem>
                                                        <DropdownItem
                                                            className="p-2 border-bottom"
                                                            onClick={() => {
                                                                props.blockUser(props.user_id, "one_to_one");
                                                            }}>
                                                            Block User
                                                        </DropdownItem>
                                                        <DropdownItem
                                                            className="p-2"
                                                            onClick={() => {
                                                                props.removeRequest(props.req_id, "one_to_one", props.user_id);
                                                            }}>
                                                            Remove
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </Dropdown>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </React.Fragment>
    );
};

export default RequestReceived;
